// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tab_tabs__Q3D30","head":"Tab_head__SPqJJ","tab":"Tab_tab__zJNsU","active":"Tab_active__X78Xa","tabContent":"Tab_tabContent__xTUUW","content":"Tab_content__iiwrK"};